import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Availability } from '../../types/user';

const initialState: Availability = {
    shiftTime: '',
    shiftDays: []
};

export const availabilitySlice = createSlice({
  name: 'availability',
  initialState,
  reducers: {
    setAvailability: (_, action: PayloadAction<Availability>) => {
      return action.payload;
    },
    clearAvailability: () => initialState,
  },
});

export const { setAvailability, clearAvailability } = availabilitySlice.actions;
export default availabilitySlice.reducer;
